

<template>
  <div>
    <div class="b-approve-container__pdf-section" v-if="!rejected">
      <label>Download PDF:</label>
      <button class="b-global__button" @click="downloadFilledPdf()">Filled PDF</button>
    </div>

    <div class="b-approve-container__btn b-approve-container__width">
      <div v-if="rejected" class="b-approve-container__rejection--container">
         <!-- <div >
           <div class="b-approve-container__category--text">Select category:</div>
           <select v-model="selectedCategory" class="b-approve-container__select">
               <option
                 v-for="(value,name) in rejectionList"
                 :value="name"
                 :key="name"
                >{{ name}}</option>
            </select>
        </div>
        <div>
           <div class="b-approve-container__category--text">{{selectedCategory==='Others' ? 'Enter' :'Select'}} rejection reason:</div>
           <select v-model="selectedSubCategory" v-if="selectedCategory!=='Others'" multiple  class="b-approve-container__select">
               <option
                 v-for="(item,index) in rejectionList[selectedCategory]"
                 :value="item"
                 :key="index"
                >{{ item }}</option>
            </select>
        </div> -->
        <div v-for="(list,name) in rejectionList" :key="name">
          <div class="b-approve-container__category--text">{{name}}:</div>
          <div v-for="(item,index) in list" :key="index" class="b-approve-container__select--checkbox">
            <input type="checkbox" :id="index" :value="item" v-model="checkedValues">
            <label :for="index">{{item}}</label>
          </div>
          
        </div>
        <div>
           <div class="b-approve-container__category--text">Others:</div>
          <textarea
          rows="5"
          cols="45"
          placeholder="Remarks"
          v-model="reason_for_rejection"
          class="b-approve-container__select"
        ></textarea>
        </div>
        
      </div>

      <div v-if="checkAuthorization()" class="b-personal-container__error">You are not authorized !</div>
      <button
        v-if="details.kyc_form_check_status =='2' || details.kyc_form_check_status=='6'"
        class="b-global__button"
        @click="submitDetails"
        :disabled="checkAuthorization()"
      >{{rejected ? 'Reject' : 'Approve' }}</button>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      picked: "",
      reason_for_rejection: "",
      rejected: false,
      rejectionList:{
    "PAN": [
    "Signature is not as per PAN. Please ensure your signature is a close replica of the signature reflecting on your PAN.",
    "Signature on PAN not available. Please complete signature on the PAN and upload a clear image of your PAN that reflects your Signature.",
    "Image of PAN card truncated/ not clear. Please upload a clear image that reflects the complete PAN.",
    "Image of PAN missing. Please upload an image of your PAN card reflecting your details.",
    "Minor PAN not accepted - Please upload image of updated PAN reflecting the photograph of applicant."
    ],
    "PHOTO": [
    "Photo should be in the format for a passport photo. Please ensure you are facing the camera directly, with entire face visible (no tinted glasses)."
    ],
    "ADDRESS": [
    "Image of Address Proof is truncated / not clear. Please upload a clear image that reflects the complete document.",
    "Second page of the Proof of address not provided - please upload image of both sides of document.",
    "Address provided does not match the proof of address provided. Please provide a valid document reflecting the correct address",
    "Image of Address Proof missing. Please upload image of valid proof of address."
    ],
    "IPV Video": [
    "Video not visible, please record IPV video and re-upload.",
    "KYC applicant not visible in video  - please record fresh video with KYC applicant and re-upload.",
    "Face in recorded video does not match with the face in Aadhaar card. Please record a new video of the same person as in Aadhaar card."
    ],
    "NRI": [
    "English translation document required for address proof. If the address proof is in a non-English language: Please take a printout of the scanned copy of the proof, translate the address into English and sign next to the translated text and re-upload.",
    "Mismatch between residence status(RI) and proof submitted (NRI). Residence status selected is Resident Individual but the Address proof submitted is Overseas Address Proof. Kindly update the correct Residence status and submit the supporting documents accordingly.",
    "Mismatch between residence status (NRI) and proof submitted (RI). Residence status selected is Non Resident Individual but the Address proof submitted is Indian Address Proof. Kindly update the correct Residence status and submit the supporting documents accordingly."
    ],
    
  },
  selectedCategory:'PAN',
  selectedSubCategory: [],
  checkedValues:[]
    };
  },
  props: {
    tabs: {
      type: Array
    },
    details: {
      type: Object
    },
    isReject: {
      type: Boolean
    }
  },
  mounted() {
    // this.$store.dispatch('fetchPdf', { id: this.$route.params.id, key: 'cvl_form' });
    this.checkApprove();
  },
  methods: {
    kycIdDetail: function(id) {
      this.$router.push({ name: "kyc-details-id", params: { id: id , partner: this.admin_partner} });
    },
    submitDetails: function() {
    // console.log(this.checkedValues.concat(this.reason_for_rejection));
    let rejections = this.reason_for_rejection!==""?this.checkedValues.concat(this.reason_for_rejection) : this.checkedValues
    let formattedList =  rejections.map((value,index)=>{
      // console.log(`${index+1}. ${value} \n`);
      return `${index+1}. ${value} \n`
    
    })
    // console.log(formattedList.join(""))
      // let errorMessage= this.selectedCategory==='Others' ? this.reason_for_rejection : this.selectedSubCategory.toString();
      let status = this.rejected ? "rejected" : "approved";
      let remarks = this.rejected ? formattedList.join("") : "";
      let cvl_audit = {};
      this.tabs.map((element, index) => {
        if (index < this.tabs.length - 1) {
          let { name, checkDetails } = element;
          let obj = {};
          name = name.toLowerCase();
          obj[name] = checkDetails;
          let data = { ...cvl_audit, ...obj };
          cvl_audit = data;
        }
      });
      cvl_audit.kyc = { file_kyc_form: this.$store.state.kycDetails.fileUrl };
      let data = { status: status, remarks: remarks, cvl_audit };
    // console.log(data.remarks)
      this.$store
        .dispatch("submitCvlQuery", { id: this.$route.params.id, data })
        .then(() => {
            this.$router.push({ name: 'kyc-details', params: {status: 'Pending', partner: this.admin_partner}});
            this.$store.commit("resetTab");
          });
    },

    downloadFilledPdf: function() {
      this.$store.dispatch("fetchPdf", {
        id: this.$route.params.id,
        key: "cvl_form"
      });
    },
    downloadCleanPdf: function() {
      this.$store.dispatch("fetchPdf", {
        id: this.$route.params.id,
        key: "cvl_pdf"
      });
    },
    onUploadFile: function(evt) {
      let files = evt.target.files || evt.dataTransfer.files;

      this.$store.dispatch("uploadFile", {
        file: files[0],
        id: this.$route.params.id,
        key: "file_kyc_form"
      });
    },
    checkAuthorization: function() {
      if (
        this.$store.state.kycLogin.admin &&
        this.$store.state.kycLogin.admin.preferences &&
        this.$store.state.kycLogin.admin.preferences.signature &&
        this.$store.state.kycLogin.admin.preferences.signature.length
      )
        return false;
      else return true;
    },
    checkApprove() {
      let isReject = false;

      for (let i = 0; i <= this.tabs.length - 2; i++) {
        if (this.tabs[i].isReject === true) {
          isReject = true;
          break;
        }
      }
      if (isReject) {
        this.$emit("changeApproveCheckMark", true);
        this.rejected = true;
      } else {
        this.$emit("changeApproveCheckMark", false);
        this.rejected = false;
      }
    }
  },
  computed: {
    ...mapGetters(["getPdfURl"]),
    ...mapState({
      admin_partner: state => state.kycLogin.admin_partner,
      kyc_verification_type: state => state.kycLogin.kyc_verification_type
    }),    
  }
};
</script>

<style scoped>
.b-approve-container__approval {
  margin-top: 30px;
  display: flex;
  justify-content: center;
  min-width: 500px;
}
.b-approve-container__pdf-section {
  display: flex;
  justify-content: center;
  align-items: center;
}
.b-approve-container__width {
  min-width: 500px;
}
.b-approve-container__upload {
  min-width: 500px;
}
.b-approve-container__btn {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 500px;
}
textarea[placeholder] {
  text-align: center;
}
.b-approve-container__btn-disable {
  margin: 35px !important;
  font-weight: 500;
  font-size: 14px;
  margin: 0;
  padding: 0;
  min-width: 70px;
  padding-left: 25px;
  padding-right: 25px;
  box-sizing: border-box;
  border: none;
  border-radius: 20px;
  box-shadow: 2px 4px 7px 0 #0000001a;
  background-color: #cccccc;
  color: #666666;
  line-height: 3em;
  height: 3em;
  cursor: not-allowed;
}
.b-personal-container__error {
  color: #d8000c;
  margin-top: 15px;
}
.disableLabel {
  color: #888;
}
.b-approve-container__select{
    width: 100%;
    background: white;
    font-size: 16px;
    margin: 16px 0;
    overflow: scroll
}
.b-approve-container__category--text{
  font-weight: 500;
  font-size: 18px;
  padding: 16px 0;
}
.b-approve-container__rejection--container{
  width: 1068px;
}
.b-approve-container__select--checkbox{
  padding: 5px 0;
}
/* .b-approve-container__text-input{
  margin: 16px;
} */
</style>